/* Tamer Adel landing theme — vanilla JS, no dependencies */
/* Theme-editor safe: re-initializes per section on shopify:section:load */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Sticky header shadow + sticky mobile buy bar ----------
     One persistent scroll/resize handler that re-queries live elements,
     so editing the header/footer sections in the theme editor never
     leaves a stale reference or leaks listeners. */
  var onScrollState = function () {
    var header = document.querySelector('[data-header]');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 20);

    var sticky = document.querySelector('[data-sticky-cta]');
    if (sticky) {
      var pricing = document.querySelector('#pricing');
      var pastHero = window.scrollY > (window.innerHeight * 0.6);
      var pricingInView = false;
      if (pricing) {
        var r = pricing.getBoundingClientRect();
        pricingInView = r.top < window.innerHeight && r.bottom > 0;
      }
      sticky.classList.toggle('is-visible', pastHero && !pricingInView);
    }
  };
  window.addEventListener('scroll', onScrollState, { passive: true });
  window.addEventListener('resize', onScrollState, { passive: true });

  /* ---------- Mobile nav toggle ---------- */
  function initNav(root) {
    var navToggle = root.querySelector('[data-nav-toggle]');
    var nav = root.querySelector('[data-nav]');
    if (!navToggle || !nav || navToggle.dataset.bound) return;
    navToggle.dataset.bound = '1';
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.classList.toggle('is-open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('nav-open', open);
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        navToggle.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('nav-open');
      });
    });
  }

  /* ---------- Accordions (FAQ + curriculum) ---------- */
  function initAccordions(root) {
    root.querySelectorAll('[data-accordion]').forEach(function (acc) {
      if (acc.dataset.bound) return;
      var btn = acc.querySelector('[data-accordion-trigger]');
      if (!btn) return;
      acc.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Animated number counters ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var decimals = (el.getAttribute('data-decimals') | 0);
    var dur = 1400, start = null;
    var step = function (ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = (target * eased);
      el.textContent = (decimals ? val.toFixed(decimals) : Math.round(val).toLocaleString('en-US')) + suffix;
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  var countObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { animateCount(e.target); countObserver.unobserve(e.target); }
    });
  }, { threshold: 0.4 }) : null;

  function initCounters(root) {
    root.querySelectorAll('[data-count]').forEach(function (c) {
      if (c.dataset.bound) return;
      c.dataset.bound = '1';
      if (countObserver) countObserver.observe(c);
      else animateCount(c);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); revealObserver.unobserve(e.target); }
    });
  }, { threshold: 0.12 }) : null;

  function initReveals(root) {
    root.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (r) {
      if (revealObserver && !prefersReduced) revealObserver.observe(r);
      else r.classList.add('is-visible');
    });
  }

  /* ---------- Init (runs on whole document, or one section in editor) ---------- */
  function init(root) {
    initNav(root);
    initAccordions(root);
    initCounters(root);
    initReveals(root);
    onScrollState();
  }

  init(document);

  /* ---------- Theme editor: re-init a section after it re-renders ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
